import { connect } from 'react-redux';
import get from 'lodash/get';

import Errors from 'dux/errors/errors';
import { getUserInitials, getIsLoginAs, getAvatarUrl } from 'dux/user/selectors';

import { dismissError } from 'dux/errors';
import { uploadUserAvatar } from './profile-dux';

import Profile from './profile';

function mapStateToProps( state ) {
    return {
        getAvatarUrl: getAvatarUrl( state ),
        isLoginAs: getIsLoginAs( state ),
        userInitials: getUserInitials( state ),
        busyAvatarUpload: get( state, 'app.fetching.userAvatar', false ),

        uploadAvatarErrors: Errors.getByType( state, Errors.ERROR_PROFILE_UPLOADUSERAVATAR ),
        maxProfileImageFileSize: state.env.MAX_PROFILE_IMAGE_FILE_SIZE || '10mb'
    };
}

const mapDispatchToProps = {
    uploadUserAvatar,
    dismissError
};

export default connect( mapStateToProps, mapDispatchToProps )( Profile );
